<!-- OpenAIComponent.svelte -->
<script>
    import { onMount } from 'svelte';
    import axios from 'axios';
    import OpenAI from 'openai'; 
    export let userInput = "";
    export let occupation = ""; 
    import List from './List.svelte';
    import SearchIcon  from './SearchIcon.svelte';
    import GameIcon from './GameIcon.svelte';
    import Write from './Write.svelte';
   
    
    let isPrototypeMode = false;

    let inputText = '';
 
     
  
    export function TriggerResponse(){
      getOpenAIResponse()
    }

    let apiKey =  "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";
    const apiUrl = 'https://api.openai.com/v1/chat/completions'; // Adjust the URL based on OpenAI API version
      
    let result = '';
    let answer ='';
    let status = '';  
    let isDesign = false;
    let isGame = false;
    let isVideo = false;
    let isInteraction = false;
    let isArticles = false;
    let reply = "";

   
    let jsonFormat = {
        "answer": {
            "isInteraction": true,
            "isDesign": false,
            "isGame": true, 
            "isVideo" : true,
            "isArticles" : true,
            "reply" : "Provide a comforting response based on what answer was returned true "
        }
    }

    let promptContent = `
  You are a bot called Fido that is helping me manage my website.
  You job is just to check the inputs by the user and see if any of the answers below is true. 
  If it is true, reflect that in the reply.
    

    Please ensure the output is in the following JSON format:
    {
        "answer": {
        "isInteraction": true,          // true/false based on whether questions is asking for interactions
        "isDesign": false,       // true/false based on whether questions is asking for design
        "isGame": true,         // true/false based on are they asking for games
        "isVideo": true,         // true/false based on are they asking for video
        "isArticles" : true,  // true/false based on are they asking for writings, articles, blog posts, case studies
        "reply": "Provide a response based on what answer was returned true such as "Here is what I found...", "This might be what you are looking for", "Here's some UX work I have done", "Here's some game design stuff I've worked on!"// Response
              }
    } 
`;

    console.log(promptContent);



    async function getOpenAIResponse() {
    try {
      const requestData = {
        messages: [
        { role: 'user', content: userInput },
          { role: 'system', content: promptContent}
        ],
        model: 'gpt-3.5-turbo-1106',
        response_format: { type: 'json_object' },
        temperature : 0,
      };

      console.log('API Request Data:', requestData);
      
      if(requestData != null ) {
        status = "loading";
      }

      const response = await axios.post(
        apiUrl,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apiKey}`,
          },
        }
      );

      console.log('API Response Data:', response.data);

      result = response.data.choices[0].message.content;
      answer = JSON.parse(result) || [];
      console.log(answer);
        if(answer != null){
          isInteraction = answer.answer.isQuestion;
          isDesign = answer.answer.isDesign;
          isGame = answer.answer.isGame;
          isVideo = answer.answer.isVideo;
          isArticles = answer.answer.isArticles;
         reply = answer.answer.reply;
        //  reply = "Here is what I found..."
        }
            
      
     
      status = '';
 
    } catch (error) {
      console.error('Error making OpenAI API request:', error);
    }
  } 

  function togglePrototypeMode() {
    isPrototypeMode = !isPrototypeMode; 
    // Additional logic for handling the mode change
  }
  let isActive = false;

  function toggle() {
    isActive = !isActive;
  }

  function handleChangeInput(event) {
    userInput = event.target.value;
	  }
  

</script>

{#if isVideo}
<div class="video-item">
  <iframe src="https://player.vimeo.com/video/668675980?h=9e015db434" width="100%" height="auto" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
  </div>


{:else }

{#if reply != null}

<div class="reply">
 {reply}
</div>


 {/if} 

{/if}




{#if isArticles}
<div class="reply">
  <Write />
<a href="https://bootcamp.uxdesign.cc/i-built-a-sci-fi-style-portfolio-website-53cb6ac440b2"> I built a Sci-fi style portfolio website. Here’s how. </a>
</div>
<div class="reply">
  <Write />
<a href="https://medium.com/singapore-gds/please-stop-talking-edc728ce8f02"> “Please stop talking…” </a>
</div>
 

{/if}

 
{#if isGame}
<div class="hologram-item">
 <GameIcon />
 <a href="https://zacting.itch.io/lynn">   LYNN </a>
</div>

<div class="hologram-item">
  <GameIcon />
  <a href="https://zacting.itch.io/dead-ringer">   Dead Ringer </a>
 </div>
{/if}

 
  {#if isDesign}
  
  <div class="hologram-item">
  <List />
  <a href="https://www.figma.com/proto/GEmhtqmH0KbyOf2Si9efgw/Issac-Portfolio-2022?page-id=101%3A2099&node-id=102%3A3104&viewport=1585%2C1090%2C0.31&scaling=min-zoom&starting-point-node-id=102%3A3104&show-proto-sidebar=1">Ember Design Language System</a>
 
  </div>
   
  <div class="hologram-item">
  <List />
  <a href="https://www.figma.com/proto/GEmhtqmH0KbyOf2Si9efgw/Issac-Portfolio-2022?page-id=101%3A2099&node-id=351-2592&viewport=1585%2C1090%2C0.31&scaling=min-zoom&starting-point-node-id=351%3A2592&show-proto-sidebar=1">   Career Coach 4.0 </a>

  </div>

  <div class="hologram-item">
  <List />
  <a href=""> Role Informer Tool </a>
   
  </div>
  {/if}
  
  {#if isInteraction}
  <div class="hologram-item">
    <List />
   In pursuit of Beauty
  </div>
 
  <div class="hologram-item">
    <List />
    hi!Carnival
  </div>
  
  {/if}
  
  {#if status == "loading"  }
  <div class="loading-status">
  loading...
  </div>
  {:else} 

{/if}   
<div class="input-wrapper">
  <input 
    class = ""
    type="text"
    id="question"
    bind:value={userInput}
    on:input={handleChangeInput}    
    placeholder="Ask in your own words..."
  />
 
</div>


<div class="orb"  on:click={getOpenAIResponse} ></div>

<style>
.hologram-item{ 
  color: #FD8834;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 16px;
  text-align: left;
  border-radius: 14px;
  padding: 8px;
  font-size: 20px;
  text-transform: uppercase;

  animation: fadeInSlideUp 1s;
  
}

.reply{
  font-size: 14px;
text-align: left;
  color: #FD8834; 
  display: flex;
    gap: 16px;
    align-items: center;
    padding: 8px;
}
.input-wrapper{
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin: 0px auto;
    justify-content: center;
  } 
  
  input#question {
	width: 540px;
	height: 62px;
	border-radius: 14px;
 
	padding: 16px;
}

    .search-icon{
        width: auto;
        background:none;
        color: #FD8834;
        border: 0px;
    }

 

    iframe {
     border-radius:24px;
    height: 315px;
}
 

    
input  {
    padding: 8px;
    margin: 8px;
    border-radius: 4px;
    width: 540px;
    height: 62px;
    border-radius: 14px;
    padding: 16px;
    text-align: left;
    background: black;
    font-weight: 400;
    color: white;
    border: 1px solid #FD8834;
}
    


  @keyframes fadeInSlideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  
.orb {
  cursor: pointer;  
  animation: spin 40s linear infinite, glow 5s ease-in-out infinite alternate;
    width: 30px;
    height: 30px;
    margin: auto; 
    position: absolute;
    bottom: 77px;
    left : 0px;
    right : 0px;
    z-index: 11;
    border-radius: 50%;
    box-shadow: inset 0 0 5px #fff, inset 20px 0 6px orange, inset -20px 0 12px #FD8834, inset 20px 0 30px orange, inset -20px 0 18px #FD8834, 0 0 50px #fff, -10px 0 60px orange, 1px 0 60px #FD8834;
  }

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes glow {
    0% {
      box-shadow:
        inset 0 0 5px #fff,
        inset 20px 0 6px orange,
        inset -20px 0 12px #FD8834,
        inset 20px 0 30px orange,
        inset -20px 0 18px #FD8834,
        0 0 50px #fff,
        -10px 0 60px orange,
        1px 0 60px #FD8834;
    }
    20% {
      box-shadow:
        inset 0 0 1px #fff,
        inset 20px 0 3px orange,
        inset -20px 0 4px #FD8834,
        inset 20px 0 15px orange,
        inset -20px 0 9px #FD8834,
        0 0 50px #fff,
        -10px 0 60px orange,
        1px 0 60px #FD8834;
    }
   50% {
      box-shadow:
        inset 0 0 5px #fff,
        inset 20px 0 6px orange,
        inset -20px 0 12px #FD8834,
        inset 20px 0 30px orange,
        inset -20px 0 18px #FD8834,
        0 0 50px #fff,
        -10px 0 20px orange,
        1px 0 20px #FD8834;
    }
    100% {
      box-shadow:
        inset 0 0 5px #fff,
        inset 20px 0 6px orange,
        inset -20px 0 12px #FD8834,
        inset 20px 0 30px orange,
        inset -20px 0 18px #FD8834,
        0 0 50px #fff,
        -10px 0 60px orange,
        1px 0 60px #FD8834,
        inset 0 0 3px orange,
        inset 0 0 5px orange,
        inset 0 0 7px orange,
        inset 0 0 9px orange,
        inset 0 0 11px orange;
    }
  }

   /* Style for input */
   input[type="text"] {
    background-color: black;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
  }

  /* Style for input when focused */
  input[type="text"]:focus , input[type="text"]:valid{
    border-color: orangered;
    background-color: black;
  }

  input:-internal-autofill-selected {
    appearance: menulist-button;
    background-image: none !important;
    background-color:black !important; 
}

input:-internal-autofill-selected {
    background-color: black;
}
  </style>